export default __webpack_public_path__ + "static/media/cwu17.81fb3990.jpeg";